var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 23,
    viewBox: "0 0 30 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62252e-06 5.00823C0.00462339 4.20581 0.174994 3.41344 0.499957 2.68298C0.840623 1.89297 1.39655 1.2199 2.10134 0.744138C2.80614 0.268379 3.63002 0.0100498 4.47457 0L25.5225 0C26.3671 0.0100498 27.1909 0.268379 27.8957 0.744138C28.6005 1.2199 29.1565 1.89297 29.4971 2.68298C29.9172 3.59198 30.079 4.60331 29.964 5.60173C29.8491 6.60014 29.4621 7.54549 28.8472 8.33002L18.3232 21.3616C17.9252 21.8727 17.4196 22.2854 16.844 22.569C16.2684 22.8527 15.6376 23 14.9985 23C14.3595 23 13.7287 22.8527 13.1531 22.569C12.5775 22.2854 12.0719 21.8727 11.6739 21.3616L1.14989 8.33002C0.404647 7.39067 -0.00141046 6.21765 3.62252e-06 5.00823Z",
    fill: "white",
    fillOpacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMenu);
export default __webpack_public_path__ + "static/media/arrowMenu.09b673dfda3c6209ba46132b06a852d9.svg";
export { ForwardRef as ReactComponent };